import { WASHER, DRYER, ACCESSORIES } from '../constants/index';

const WASHER_MOCK = {
  specs: {
    defaultProductId: '328425526',
    category: WASHER
  },
  variants: [
    {
      name: 'Agitator/Impeller Type',
      id: '328425526',
      guid: 'b2a7875c-ab07-4ab2-9fb5-521ee16eb183',
      value: 'Agitator',
      __typename: 'BundleSDSkuAttributes'
    },
    {
      name: 'Agitator/Impeller Type',
      id: '329500038',
      guid: 'b2a7875c-ab07-4ab2-9fb5-521ee16eb183',
      value: 'Impeller',
      __typename: 'BundleSDSkuAttributes'
    }
  ]
};

const DRYER_MOCK = {
  specs: {
    defaultProductId: '312440161',
    category: DRYER
  },
  variants: [
    {
      name: 'Dryer Fuel Type',
      id: '312429905',
      guid: 'aacb73e8-7810-4d9e-8f23-e5ac86ef7f3f',
      value: 'Gas',
      __typename: 'BundleSDSkuAttributes'
    },
    {
      name: 'Dryer Fuel Type',
      id: '312440161',
      guid: 'aacb73e8-7810-4d9e-8f23-e5ac86ef7f3f',
      value: 'Electric',
      __typename: 'BundleSDSkuAttributes'
    }
  ]
};

const ACCESSORY_MOCK = {
  specs: {
    defaultProductId: '322848433',
    category: ACCESSORIES
  },
  variants: [
    {
      name: 'Laundry Accessory',
      id: '323760403',
      guid: 'aacb73e8-7810-4d9e-8f23-e5ac86ef7f3f',
      value: 'Stacking Kit',
      __typename: 'BundleSDSkuAttributes'
    },
    {
      name: 'Laundry Accessory',
      id: '322848433',
      guid: 'aacb73e8-7810-4d9e-8f23-e5ac86ef7f3f',
      value: 'Storage Pedestal',
      __typename: 'BundleSDSkuAttributes'
    }
  ]
};

export const LAUNDRY_MOCK = {
  [WASHER]: WASHER_MOCK,
  [DRYER]: DRYER_MOCK,
  [ACCESSORIES]: ACCESSORY_MOCK
};